// The settings page sets this query param after an opt-out. The landing banner reads it once.
export const OPTED_OUT_PARAM = 'optedOut'
